module.exports = __webpack_public_path__ + "img/user-male.a5d2d1f5.png";